import { ErrorHandler, Injectable } from "@angular/core";
import { ApplicationInsightsService } from "./insights.service";

@Injectable()
export class ErrorHandlerService extends ErrorHandler {

    constructor(private appInsightsService: ApplicationInsightsService) {
        super();
    }

    override handleError(error: Error) {
        this.appInsightsService.logException(error); // Manually log exception
    }
}